"use client"

import styled from "@emotion/styled"
import { Box, SxProps, Theme } from "@mui/material"

const StyledContainer = styled(Box)<{
  $maxWidth: number | string
  $maxWidthXL?: number | string
  $paddingInline?: number
}>`
  width: 100%;
  max-width: ${(props) =>
    typeof props.$maxWidth === "string" ? props.$maxWidth : `${props.$maxWidth}px`};
  margin: 0 auto;
  padding-inline: ${(props) => (props.$paddingInline ? `${props.$paddingInline}px` : "0")};
  ${(props) => props.theme.breakpoints.up("xl")} {
    max-width: ${(props) =>
      props.$maxWidthXL
        ? typeof props.$maxWidthXL === "string"
          ? props.$maxWidthXL
          : `${props.$maxWidthXL}px`
        : `${props.$maxWidth}px`};
  }
`
export type PortContainerProps = {
  maxWidth?: number | string
  maxWidthXL?: number | string
  paddingInline?: number
  sx?: SxProps<Theme>
  children: React.ReactNode
}
const PortContainer = ({
  maxWidth,
  maxWidthXL,
  paddingInline,
  sx,
  children,
}: PortContainerProps) => {
  const maxWidthValue = maxWidth || 1040
  const maxWidthXLValue = maxWidthXL || maxWidthValue
  return (
    <StyledContainer
      $maxWidth={
        typeof maxWidthValue === "string"
          ? maxWidthValue
          : paddingInline
          ? maxWidthValue + paddingInline * 2
          : maxWidthValue
      }
      $maxWidthXL={
        typeof maxWidthXLValue === "string"
          ? maxWidthXLValue
          : paddingInline
          ? maxWidthXLValue + paddingInline * 2
          : maxWidthXLValue
      }
      $paddingInline={paddingInline}
      {...(sx ? { sx } : {})}
    >
      {children}
    </StyledContainer>
  )
}
export default PortContainer
